import React from 'react'
import * as base from 'components/BandSlider/BandSlider.module.scss'
import * as theme from 'components/BandSlider/BandSlider-theme.module.scss'

let styles = {}
Object.assign(styles, base, theme)

/*
  technique from
  https://ryanmulligan.dev/blog/css-marquee/
  https://codepen.io/hexagoncircle/pen/wvmjomb

*/
export const BandSlider = ({
  images: imagesProp,
  speed = '120s',
  gap = '20px',
}) => {
  const style = {
    '--duration': speed,
    '--gap': gap,
  }

  return (
    <div id="band-slider" className={styles.root} style={style}>
      <div className={styles.marquee}>
        <div className={styles.marqueeGroup}>
          {[...imagesProp].map((image, i) => (
            <img className={styles.img} src={image} alt="" key={i} />
          ))}
        </div>
        <div className={styles.marqueeGroup} aria-hidden="true">
          {[...imagesProp].map((image, i) => (
            <img className={styles.img} src={image} alt="" key={i} />
          ))}
        </div>
      </div>
    </div>
  )
}
